import { oc } from 'ts-optchain'

import { isFunction } from '@/utils/validationUtils'

export const queryStringToObject = <T>(
  querystring: string,
  initialObject: T,
): Record<keyof typeof initialObject, any> => {
  const params = new URLSearchParams(querystring)

  return Object.keys(initialObject).reduce((result, key) => {
    const initialValue = (initialObject as any)[key]
    if (isFunction(initialValue)) {
      const value = params.get(key) || ''

      return {
        ...result,
        [key]: initialValue(value) as string,
      }
    } else {
      const value = params.get(key) || initialValue || ''

      return {
        ...result,
        [key]: value,
      }
    }
  }, initialObject)
}

export const objectToQueryString = <T>(initialObject: T): string => {
  return Object.keys(initialObject).reduce((result, key, index, self) => {
    const value = oc(initialObject as any)[key]('')
    const separator = index === self.length - 1 ? '' : '&'

    return `${result}${key}=${value}${separator}`
  }, '?')
}
